// Product copy. `id` links each item to its photo in Products.js and must match across languages.
// `bestFor` mirrors the recommendations on the Grade Guide.
const products = {
  title: 'Products',
  lead: 'Seven Ceylon cinnamon grades, plus cinnamon oil, pepper and arecanut. Tick what you\'re interested in and request a single quote for all of it.',
  guidePrompt: 'Not sure which grade fits?',
  guideLink: 'Read the grade guide →',
  samplesPrompt: 'Want to check quality first?',
  samplesLink: 'Request samples →',

  tableCaption: 'Ceylon cinnamon grades and specifications',
  columns: { grade: 'Grade', diameter: 'Diameter', colour: 'Colour', bestFor: 'Best for', packing: 'Packing', add: 'Add to quote' },
  // Marks specs we haven't published yet; shown muted
  onRequest: 'On request',

  groups: [
    {
      title: 'Continental quills',
      note: 'The thinner, paler grades. Graded by quill diameter.',
      items: [
        { id: 'c5', name: 'C5', diameter: '10–12 mm', colour: 'Tan yellow', bestFor: 'Retail sticks, gift packs, cafés', packing: 'To your specification' },
        { id: 'c4', name: 'C4', diameter: '13–16 mm', colour: 'Golden / pale yellow', bestFor: 'Retail sticks, tea and coffee', packing: 'To your specification' },
      ],
    },
    {
      title: 'Hamburg quills',
      note: 'Wider, thicker quills. Usually ground or milled.',
      items: [
        { id: 'h1', name: 'H1', diameter: '25–27 mm', colour: 'Golden brown', bestFor: 'Grinding, bakeries, spice blends', packing: 'To your specification' },
        { id: 'h2', name: 'H2', diameter: '28–32 mm', colour: 'Golden brown', bestFor: 'Grinding, bakeries, spice blends', packing: 'To your specification' },
        { id: 'h3', name: 'H3', diameter: 'On request', colour: 'On request', bestFor: 'Grinding and industrial milling', packing: 'To your specification' },
      ],
    },
    {
      title: 'Pieces',
      note: 'Same bark, irregular shapes. Sold by weight.',
      items: [
        { id: 'quillings', name: 'Quillings', diameter: 'Broken quill pieces', colour: 'Mixed', bestFor: 'Grinding, infusions, blends', packing: 'Plastic bags' },
        { id: 'offcuts', name: 'Off cuts', diameter: 'Trimmed quill ends', colour: 'Mixed', bestFor: 'Industrial milling and extraction', packing: '5 kg or 10 kg boxes' },
      ],
    },
  ],

  othersTitle: 'Other products',
  others: [
    { id: 'oil', name: 'Cinnamon oil', detail: 'Leaf oil and bark oil' },
    { id: 'pepper', name: 'Pepper', detail: 'Black peppercorns' },
    { id: 'arecanut', name: 'Arecanut', detail: 'Dried betel nut' },
  ],

  galleryTitle: 'From our stock',
  terms: ['Graded to SLS 81', 'Samples available', 'Payment before production', 'EXW, FOB, CFR, CIF or DAP', 'Private label available'],
  termsLink: 'How ordering works →',

  add: 'Add',
  added: 'Added',
  addLabel: (name) => `Add ${name} to quote`,
  removeLabel: (name) => `Remove ${name} from quote`,
  photoLabel: (name) => `Photo of ${name}`,
  previewLabel: (name) => `${name} photo`,
  close: 'Close',
  selectedCount: (n) => `${n} selected`,
  clear: 'Clear',
  requestQuote: 'Request quote',
  requestSamples: 'Samples',
};

export default products;
